<template>
  <stripe-checkout
    ref="checkout"
    :pk="apiKey"
    :items="plans[plan].items"
    :hidden="hidden"
    :customer-email="user && user.email"
    :success-url="fullSuccessUrl"
  >
    <template slot="checkout-button">
      <v-btn
        @click="redirectToCheckout"
      >
        {{ plans[plan].buttonText }}
      </v-btn>
    </template>
  </stripe-checkout>
</template>

<script>
import { StripeCheckout } from 'vue-stripe-checkout';
import { mapState } from 'vuex';

const testApiKey = 'pk_test_1fs38uvMU02UOY6D3VzD3x9200PjtHekh9';

export default {
  components: {
    StripeCheckout,
  },
  props: {
    plan: {
      type: String,
      default: 'monthly',
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    successUrl: {
      type: String,
      default: 'scan/list',
    },
  },
  data() {
    return {
      apiKey: process.env.VUE_APP_STRIPE_API_KEY || testApiKey,
      plans: {
        monthly: {
          buttonText: '$1.39/month (billed monthly)',
          items: [{
            plan: 'plan_HJEWjwZw4Efsj0',
            quantity: 1,
          }],
        },
        yearly: {
          buttonText: '$0.99/month (billed yearly)',
          items: [{
            plan: 'plan_HJEWhiGQqe9q1z',
            quantity: 1,
          }],
        },
      },
    };
  },
  computed: {
    fullSuccessUrl() {
      return 'https://neuralike.com/#/scan/list';
    },
    ...mapState('auth', ['user']),
  },
  methods: {
    redirectToCheckout() {
      this.$refs.checkout.redirectToCheckout();
    },
  },
};
</script>
